import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { ChevronDownIcon } from '@icons/ChevronDownIcon'
import { ChevronUpIcon } from '@icons/ChevronUpIcon'

import { NameDto } from '@model/NameDto'

import { Button } from '@global/button/Button'

import { DialogModal } from '../DialogModal'
import type { ModalProps } from '../types'

import styles from './SortModalDesktop.module.scss'

interface SortModalProps extends PropsWithChildren<ModalProps> {
  title: string
  options: SortOption[]
  isLoading?: boolean
  onConfirm(option: string, sortBy: SortOrder, sortName: string): void
}

type SortOption = string | NameDto<string>
type SortOrder = 'ASC' | 'DESC'

export const SortModalDesktop: React.FC<SortModalProps> = (props) => {
  const { title, isLoading, onClose } = props

  const { t } = useTranslation()

  return (
    <DialogModal
      title={title}
      isLoading={isLoading}
      renderFooter={({ onClose }) => [
        <Button appearance='ghost' size='S' type='button' onClick={onClose}>
          {t('Cancel')}
        </Button>,
      ]}
      onClose={onClose}
    >
      <SortOptions {...props} />
    </DialogModal>
  )
}

const SortOptions: React.FC<SortModalProps> = (props) => {
  const { options } = props

  return (
    <section className={classNames('modal-card-body', styles.body)}>
      {options.map((option) => {
        const id = typeof option === 'string' ? option : option.id
        const name = typeof option === 'string' ? option : option.name
        return <SortOption {...props} id={id} name={name} />
      })}
    </section>
  )
}

export type SortOptionType = NameDto<string>

const SortOption: React.FC<SortModalProps & SortOptionType> = (props) => {
  const { id, name, onConfirm } = props

  return (
    <div className={styles.option} key={id}>
      <span>{name}</span>
      <div className={styles.sort}>
        <span className={styles.sortBy} onClick={() => onConfirm(id, 'DESC', name)}>
          <ChevronDownIcon />
        </span>
        <span className={styles.sortBy} onClick={() => onConfirm(id, 'ASC', name)}>
          <ChevronUpIcon />
        </span>
      </div>
    </div>
  )
}
